<!--
Copyright (c) 2020 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details.
-->

<!-- submit button for user registration -->
<template>
        <button :class="['ies-btn primary cta-button', {'disabled': loading || disabled}, {'buttondisp': useSpacing}]" :aria-busy="loading ? 'true' : 'false'" :disabled="loading || disabled" type="button" @click="$emit('click')">
            <span :class="[{'align-self-start': !large, 'm-auto': large}]" style="text-align:center;">
                {{label}}
            </span>
            <span :class="['fr-grow', {'fr-grow-in': loading}]">
                <transition name="fr-fade">
                    <clip-loader v-if="loading" :color="'white'" :size="'1rem'" class="position-relative fr-clip-loader ml-3"></clip-loader>
                </transition>
            </span>
            <span class="sr-only" aria-live="polite">
            {{ loading ? $t('common.form.loading') : '' }}
            </span>
        </button>
</template>
<script>
import { ClipLoader } from 'vue-spinner/dist/vue-spinner.min.js';

/**
 * @description Button with built in loading spinner that can be used to show users something is loading
 *
 **/
export default {
    name: 'LoadingButton',
    components: { ClipLoader },
    props: {
        label: String,
        loading: {
            type: Boolean,
            default: false
        },
        large: {
            type: Boolean,
            default: false
        },
        useSpacing: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../scss/tokens.css';
@import '../../scss/button.css';
</style>
